import styled from 'styled-components';

// título de coluna com explicação ao passar o mouse
export const ColumnHint = styled.span`
    cursor: help;
    border-bottom: 1px dotted currentColor;
`
